var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1010 -405 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1023,414.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3l-3.7,3.7c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1 l-3.8-3.8c-0.1-0.1-0.1-0.3-0.1-0.4c0.1-0.2,0.2-0.2,0.4-0.2h2.3v-4.1c0-0.1,0-0.2,0.1-0.3s0.2-0.1,0.3-0.1h2.3 c0.1,0,0.2,0,0.3,0.1s0.1,0.2,0.1,0.3v4.1h2.3C1022.9,414,1022.9,414,1023,414.1z M1022.2,408.5c-1-0.6-2-0.9-3.2-0.9 s-2.2,0.3-3.2,0.9s-1.8,1.3-2.3,2.3s-0.9,2-0.9,3.2s0.3,2.2,0.9,3.2s1.3,1.8,2.3,2.3s2,0.9,3.2,0.9s2.2-0.3,3.2-0.9 s1.8-1.3,2.3-2.3s0.9-2,0.9-3.2s-0.3-2.2-0.9-3.2S1023.2,409.1,1022.2,408.5z M1026.8,409.5c0.8,1.4,1.2,2.9,1.2,4.5 s-0.4,3.1-1.2,4.5s-1.9,2.5-3.3,3.3s-2.9,1.2-4.5,1.2s-3.1-0.4-4.5-1.2s-2.5-1.9-3.3-3.3s-1.2-2.9-1.2-4.5s0.4-3.1,1.2-4.5 s1.9-2.5,3.3-3.3s2.9-1.2,4.5-1.2s3.1,0.4,4.5,1.2S1026,408.1,1026.8,409.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.46e45d09fe7d96f44e0ecfb2553b49f8.svg";
export { ForwardRef as ReactComponent };